// The Primary quote picker on an opportunity: only its own quotes.
import type { FilterOption } from '@olytic/foundation';

import { type ObjectRow, parseObjectListResponse, relatedUrl } from '../objects/objectsApi';

type Fetch = (input: string, init?: RequestInit) => Promise<Response>;

const str = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');

/** A quote as the lookup shows it: number and name (Q-000012 · Phase one). */
export const quoteLabel = (row: ObjectRow): string =>
  [str(row.quote_number), str(row.name)].filter(Boolean).join(' · ') || row.id;

/** Options for an opportunity's Primary quote: its quotes, matching the query. */
export function quoteOptionsFor(fetcher: Fetch, opportunityId: string) {
  return async (query: string): Promise<FilterOption[]> => {
    const q = query.trim().toLowerCase();
    const page = await parseObjectListResponse(await fetcher(relatedUrl('opportunities', opportunityId, 'quotes', { limit: 100, offset: 0 })));
    return page.rows
      .map((row) => ({ value: row.id, label: quoteLabel(row) }))
      .filter((option) => q === '' || option.label.toLowerCase().includes(q));
  };
}
